import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify, {
  iconfont: "md"
});

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#DBE1F1",
        success: "#BFCEE7",
        secondary: "#8C9DA7",
        accent: "#B71C1C",
        info: "#ABC0DF",
        error: "#F83E70"
      }
    }
  }
});
